module.exports = __webpack_public_path__ + "static/img/on2.465036af.gif";